


import React, { useEffect, useState } from "react";
import { Button, DatePicker, Modal, Select, Space, Input, Form } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Option } from "antd/es/mentions";
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

export const UserFilters = ({ form, isModalOpen, handleCancel, setFilterForm, filterForm, handleFilter }) => {

  return (
    <>
      <Modal
        title="Filters"
        open={isModalOpen}
        onOk={handleFilter}
        okText={"Filter Data"}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            <Form.Item
              name="name"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the  name!" },
              ]}
            >
              <Input value={filterForm?.name} onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })} size="large" placeholder="filter by  name" />
            </Form.Item>

            <Form.Item
              name="email"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the  email!" },
              ]}
            >
              <Input value={filterForm?.email} onChange={(e) => setFilterForm({ ...filterForm, email: e.target.value })} size="large" placeholder="filter by email" />
            </Form.Item>
        
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Form.Item
              name="status"
              className="subscription-plan"
            >
              <Select
                value={filterForm?.status}
                onChange={(value) => setFilterForm({ ...filterForm, status: value })}
                placeholder="filter by status"
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
                options={[
                  {
                    value: "0",
                    label: "InActive",
                  },
                  {
                    value: "1",
                    label: "Active",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="mobile"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the  phone!" },
              ]}
            >
              <Input value={filterForm?.mobile} onChange={(e) => setFilterForm({ ...filterForm, mobile: e.target.value })} size="large" placeholder="filter by phone" />
            </Form.Item>
          </div>
          <div>
            <Space direction="vertical" size={12} style={{ marginBottom: "20px" }}>
              {/* <RangePicker disabledDate={disabledDate} /> */}
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};
